import n20201202 from './20201202'
import n20201220 from './20201220'
import n20210420 from './20210420'
import n20210619 from './20210619'
import n20211011 from './20211011'
import n20211012 from './20211012'
import n20211013 from './20211013'
import n20220117 from './20220117'
import n20220802 from './20220802'

export default {
  20201202: n20201202,
  20201220: n20201220,
  20210420: n20210420,
  20210619: n20210619,
  20211011: n20211011,
  20211012: n20211012,
  20211013: n20211013,
  20220117: n20220117,
  20220802: n20220802
}
